<template>
  <v-layout>
    <v-dialog v-model="show" max-width="800px" lazy>
      <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
        <v-card>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click.stop="show=false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit BSD</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
            <v-btn dark flat @click="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">SPONSOR</span>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.company"
                    label="Company Name"
                    ref="focusName"
                    :rules="[v => !!v || 'Company Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="person"
                    v-model="editedItem.contact"
                    label="Contact"
                    :rules="[v => !!v || 'Contact is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="email"
                    label="Email"
                    type="email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.address"
                    label="Address"
                    :rules="[v => !!v || 'Address is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs10 md5>
                      <v-text-field
                        v-model="editedItem.city"
                        label="City"
                        :rules="[v => !!v || 'City is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 md2>
                      <v-text-field
                        v-model="editedItem.state"
                        label="ST"
                        mask="AA"
                        :rules="[v => !!v || 'State is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="editedItem.zip"
                        label="Zipcode"
                        mask="#####"
                        :rules="[v => !!v || 'Zip is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.phone"
                    label="Phone"
                    mask="(###) ###-####"
                    return-masked-value
                    prepend-icon="stay_current_portrait"
                    :rules="[v => !!v || 'Primary Phone is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">CREDIT CARD INFORMATION</span>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.number"
                    label="Credit Card Number"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.cardName"
                    label="Name on Card"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md3>
                  <v-text-field
                    v-model="editedItem.expire"
                    label="Expires"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 offset-md1>
                  <v-text-field
                    v-model="editedItem.cardApproval"
                    label="Approval"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 offset-md1>
                  <v-text-field
                    v-model="editedItem.amount"
                    label="Amount"
                    :rules="[v => !!v || 'Amount is required']"
                    mask="###.##"
                    prefix="$"
                    readonly
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">CONTESTANT #1</span>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="person"
                    v-model="editedItem.repOneName"
                    label="Contestant #1 Name"
                    :rules="[v => !!v || 'Contestant #1 name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="email"
                    label="Contestant #1 Email"
                    type="email"
                    v-model="editedItem.repOneEmail"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.repOnePhone"
                    label="Contestant #1 Phone"
                    mask="(###) ###-####"
                    return-masked-value
                    prepend-icon="stay_current_portrait"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">CONTESTANT #2</span>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="person"
                    v-model="editedItem.repTwoName"
                    label="Contestant #2 Name"
                    :rules="[v => !!v || 'Contestant #2 name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="email"
                    label="Contestant #2 Email"
                    type="email"
                    v-model="editedItem.repTwoEmail"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.repTwoPhone"
                    label="Contestant #2 Phone"
                    mask="(###) ###-####"
                    return-masked-value
                    prepend-icon="stay_current_portrait"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">PERFORMANCE CHOICES:</span>
                </v-flex>
                <v-flex xs12 md6>
                <v-select
                  v-model="editedItem.prefNight1"
                  :items="dates"
                  item-text="text"
                  item-value="value"
                  label="1sr Choice"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="editedItem.prefNight2"
                  :items="dates"
                  item-text="text"
                  item-value="value"
                  label="2nd Choice"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="editedItem.night"
                  :items="dates"
                  item-text="text"
                  item-value="value"
                  label="Night"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editedItem.notes"
                  label="Notes"
                  prepend-icon="notes"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="printForm"
          >Print Form</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'
import moment from 'moment'

export default {
  props: ['visible', 'item'],

  data () {
    return {
      valid: true,
      currentYear: 0,
      saving: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedItem: this.item,
      titleName: '',
      dates: [],
      finalsDate: ''
    }
  },

  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  },

  created () {
    this.titleName = this.$store.state.user.Title.name
    this.currentYear = this.$store.state.currentYear

    this.getDates()
    this.setFields()
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  methods: {
    loadItem () {
      this.editedItem = this.item

      this.formattedDate = moment(this.editedItem.birthDate).format('MM/DD/YYYY')
    },

    async getDates () {
      try {
        const response = await Api().get('bsd_dates/' + this.currentYear)

        const dates = response.data

        const selectDates = []
        let date = {}

        for (let i in dates) {
          if (dates[i].status === 'finals') {
            this.finalsDate = moment(String(dates[i].date)).format('MM/DD/YYYY')
          } else {
            date.value = dates[i].date
            date.text = dates[i].night
            selectDates.push(date)
            date = {}
          }
        }

        this.dates = selectDates
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    setFields () {
      this.editedItem.number = this.editedItem.cardNumber
      this.editedItem.expire = this.editedItem.cardExpire
      this.editedItem.Cvv = this.editedItem.cardCvv
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    async printForm (date) {
      try {
        await Api().post('get_pdf/' + this.editedItem.id, this.editedItem).then((response) => {
          window.open(process.env.API_URL + '/attachments/out.pdf', '_blank')

          // console.log(route)
          console.log(response)
        })
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    save () {
      if (this.$refs.form.validate()) {
        if (this.editedItem.id > 0) {
          // console.log('Update')
          this.updateItem(this.editedItem)
        } else {
          // console.log('Save')
          this.addItem(this.editedItem)
        }
      } else {
        this.snackbar.message = 'You have some errors on the page!'
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async addItem () {
      try {
        this.editedItem.year = this.currentYear

        const response = await Api().post('teams/', this.editedItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        const response = await Api().put('teams/' + this.editedItem.id, this.editedItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/bsd/InternalForm.vue